var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      flexShrink: 0
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0H8.2093C8.54669 0 8.86133 0.170125 9.04607 0.452438L11.5164 4.22756C11.7012 4.50987 12.0158 4.68 12.3532 4.68H27C27.5523 4.68 28 5.12772 28 5.68V22C28 24.2091 26.2091 26 24 26H4C1.79086 26 0 24.2091 0 22V1Z",
    fill: "#416FF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 2.6001H9.46094H11.8535H24.5V15.1668H2.625V2.6001Z",
    fill: "#ECF0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.7666H8.75H11.8125H27C27.5523 4.7666 28 5.21432 28 5.7666V24.9999C28 25.5522 27.5523 25.9999 27 25.9999H1C0.447715 25.9999 0 25.5522 0 24.9999V4.7666Z",
    fill: "#5694F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.0c6ae040c8c149ceacb007d1a7d84ac8.svg";
export { ForwardRef as ReactComponent };